export const suppressPostSignupPopups = (userId: string): void => {
  localStorage.setItem(`candidateSortAnnouncement-${userId}`, 'false');
};
